import React from "react";
import { Box, makeStyles, Grid, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import { LinkedIn } from "@material-ui/icons";
import "./icons.css";
import LabelHtmlToTextCustom from "../../../components/LabelHtmlToTextCustom/LabelHtmlToTextCustom";

const ContactInformationsTable = ({ fonction, statut, email, mobile, telFix, linkedIn, Manager, sachezQue, directionName, nom_societe, localisation }) => {
  const useStyles = makeStyles({
    table: {
      marginTop: 20,
      boxShadow: "rgb(0 0 0 / 50%) 0px 0px 15px",
    },
    cards: {
      padding: "15px",
      boxShadow: "none",
    },
    contactTable: {
      "& strong": {
        color: "#117aa7",
      },
    },
  });

  const classes = useStyles();


  const tableData = [
    {
      title: 'MOBILE',
      value: mobile ? mobile.replace(/(\d{2})\D?(\d{1})\D?(\d{2})\D?(\d{2})\D?(\d{2})\D?(\d{2})/, "$1 $2 $3 $4 $5 $6") : "-",
    },
    {
      title: 'TÉL.FIXE DIRECT',
      value: telFix ? telFix.replace(/(\d{2})\D?(\d{1})\D?(\d{2})\D?(\d{2})\D?(\d{2})\D?(\d{2})/, "$1 $2 $3 $4 $5 $6") : "-",
    },
    {
      title: 'EMAIL PRO',
      value: email,
    },
    {
      title: 'LINKEDIN',
      value: (
        <a href={linkedIn} target="_blank" rel="noreferrer">
          <LinkedIn sx={{ height: 20 }} />
        </a>
      ),
    },
    {
      title: 'DIRECTION',
      value: directionName ? directionName.toUpperCase() : "-",
    },
    {
      title: 'LOCALISATION',
      value: localisation ?? "-",
    },
  ];

  const tableRows = [
    { label: 'SOCIÉTÉ', value: nom_societe },
    { label: 'FONCTION', value: fonction },
    { label: 'STATUT', value: statut },
    { label: 'ACCOUNT MANAGER', value: Manager },
    { label: 'SACHEZ QUE', value: <LabelHtmlToTextCustom data={sachezQue} /> },
  ];

  return (
    <Box className={classes.cards} style={{ paddingTop: 0 }}>
      <TableContainer className={classes.table}>
        <Grid container >
          <Grid item sm={12} md={6} xl={6}>
            <Table className={"table table-striped "}>
              <TableBody component="tbody">
                {tableData.map((row) => (
                  <TableRow key={row.title}>
                    <TableCell style={{ fontSize: "0.8rem", width: "50%" }} scope="row">
                      <strong>{row.title}</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: "0.8rem", width: "50%", padding: !(row.title == + "LINKEDIN") ? "0.75rem" : "0.5rem" }} align="right">
                      {row.value}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid item sm={12} md={6} xl={6}>
            <Table className={"table table-striped"}>
              <TableBody component="tbody">
                {tableRows.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell style={{ fontSize: "0.8rem", width: "50%" }} scope="row">
                      <strong>{row.label}</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: "0.8rem", width: "50%", textTransform: "capitalize", padding: "0.75rem" }} align="right">
                      {row.value}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </TableContainer>
    </Box>
  );
};

export default ContactInformationsTable;
